export enum PaymentProviderType {
  Skrill = 'Skrill',
  Bank = 'Bank',
}
